import React from 'react';
import { Button, Box, Typography } from '@mui/material';

interface TabButtonProps {
  text: string;
  onClick: () => void;
  isActive: boolean;
}

const TabButton = (props: TabButtonProps) => {
  return (
    <Typography
      onClick={props.onClick}
      sx={{
        flexGrow: 1,
        color: props.isActive ? 'primary.main' : '#ffffff',
        backgroundColor: props.isActive ? '#ffffff' : 'primary.main',
        cursor: 'pointer',
        padding: 2,
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: props.isActive ? 600 : 500,
        letterSpacing: '1px'
      }}
    >
      {props.text}
    </Typography>
  );
};

export default TabButton;
